import { LangType } from '../../helpers/lang';
import { buildParams } from '../../helpers/path';
import { PaginationRequest } from '../../types/pagination';
import { CustomCacheRequest, SortType } from '../../types/props';
import { DishCategoryType } from './dish-category-api';
import { managerApiUrl } from './manager-api';
import { baseFetch } from './utils.ts/base-fetch';

export type DishSectionType = {
  id: number;
  name: LangType;
  dishes_count: number;
  staff_tags: number[];
  menu_id: string;
  categories?: DishCategoryType[];
  sort_order: number;
};

const baseUrl = `${managerApiUrl}/menu`;

export type FetchDishSectionRequest = {
  name?: string;
  count?: string;
  field?: 'name' | 'section' | string;
  dir?: SortType | string;
} & PaginationRequest &
  CustomCacheRequest;

export const fetchSections = async (
  params: FetchDishSectionRequest,
): Promise<{ sections: DishSectionType[] }> => {
  const { customCache, ...other } = params;
  const response = await baseFetch(baseUrl + '/section' + buildParams(other), { customCache });
  return response;
};

export const putSection = async (params: Partial<DishSectionType>): Promise<DishSectionType> => {
  const response = await baseFetch(baseUrl + `/section/${params.id}`, {
    method: 'PUT',
    body: JSON.stringify(params),
  });
  return response;
};

export const postSection = async (params: Partial<DishSectionType>): Promise<DishSectionType> => {
  const response = await baseFetch(baseUrl + `/section`, {
    method: 'POST',
    body: JSON.stringify(params),
  });
  return response;
};

const isFullDeleteParam = {
  is_full_delete: false,
};

export const deleteSection = async (id: string): Promise<void> => {
  const response = await baseFetch(baseUrl + `/section/${id}` + buildParams(isFullDeleteParam), {
    method: 'DELETE',
  });
  return response;
};

export const putSectionsOrder = async (order: number[]) => {
  const response = await baseFetch(baseUrl + `/section/order`, {
    method: 'PUT',
    body: JSON.stringify({ order }),
  });
  return response;
};
